<template>
    <div class="answer">
        <div class="questionnaire-title-text">
            <div v-if="env === 'wxapp'" class="questionnaire-title-back" @click="goback">
                <img :src="backImg" alt="">
            </div>
            <div class="questionnaire-name">
                <span>{{answerInfo.name}}</span>
            </div>
        </div>

        <div class="answer-content" >
            <div class="answer-content-title" v-if="answerInfo.is_show_score === '1' || answerInfo.is_show_qrcode === '1'">
                <div class="answer-content-score" v-if="answerInfo.is_show_score === '1'">
                    得分：<span>{{answerInfo.user_answer_score}}</span>分
                </div>

                <div class="answer-content-qrcode" @click="handleShowQrcode" v-if="answerInfo.is_show_qrcode === '1'">
                    <img :src="qrcodeImg" alt="">
                    <span>显示答卷二维码</span>
                </div>
            </div>

            <div class="answer-list" :style="`top: ${(answerInfo.is_show_score === '1' || answerInfo.is_show_qrcode === '1') ? '1.12rem' : '0px'}`">
                <div :ref="`answer-item-${answerKey}`" class="answer-item" v-for="(answerItem, answerKey) in answerList" :key="answerKey">
                    <Radio disabled  v-model="answerItem.answers" :content="`${answerKey+1}、${answerItem.content}`" :options="answerItem.options" v-if="answerItem.type === questionTypeDict.radio"></Radio>

                    <Checkbox disabled  v-model="answerItem.answers" :content="`${answerKey+1}、${answerItem.content}`" :options="answerItem.options" v-if="answerItem.type === questionTypeDict.checkbox"></Checkbox>

                    <FillBlank disabled  v-model="answerItem.answers" :content="answerItem.content" v-if="answerItem.type === questionTypeDict.fillBlank" :questionnKey="answerKey+1"></FillBlank>

                    <BriefAnswer disabled  v-model="answerItem.answers" :content="`${answerKey+1}、${answerItem.content}`" v-if="answerItem.type === questionTypeDict.briefAnswer"></BriefAnswer>

                    <Scale disabled  v-model="answerItem.answers" :content="`${answerKey+1}、${answerItem.content}`" :options="answerItem.options" v-if="answerItem.type === questionTypeDict.scale"></Scale>

                    <Nationality disabled v-model="answerItem.answers" :content="`${answerKey+1}、${answerItem.content}`" v-if="answerItem.type === questionTypeDict.nationality"></Nationality>

                    <District disabled v-model="answerItem.answers" :content="`${answerKey+1}、${answerItem.content}`" v-if="answerItem.type === questionTypeDict.district"></District>

                    <Select disabled  v-model="answerItem.answers" :content="`${answerKey+1}、${answerItem.content}`" v-if="answerItem.type === questionTypeDict.select" :options="answerItem.options"></Select>

                    <IndividualFillBlank  disabled v-model="answerItem.answers" :content="`${answerKey+1}、${answerItem.content}`" v-if="answerItem.type === questionTypeDict.individualFillBlank"></IndividualFillBlank>

                    <MatrixFillBlank disabled v-model="answerItem.answers" :content="`${answerKey+1}、${answerItem.content}`" v-if="answerItem.type === questionTypeDict.matrixFillBlank"></MatrixFillBlank>
                </div>
            </div>
        </div>

        <sdDialog v-model="showQrcode" title="显示答卷二维码" cancelText="好的，我知道了">
            <div>
                <div class="questionnaire-qrcode">
                    <img :src="answerInfo.qrcode_info" alt="" @click="showEnlarge">
                    <span>出示此二维码以扫描完成绑定</span>
                </div>
            </div>
        </sdDialog>

        <div v-if="isEnlarged" class="enlarged-image-overlay" @click="hideEnlarge">
          <img class="enlarged-image" :src="answerInfo.qrcode_info" alt="">
        </div>

    </div>
</template>

<script>
import { getENV, isEmpty, getRequestClient } from '../../../utils/common'
import backImg from '@/assets/reserve/questionnaire/back.png'
import qrcodeImg from '@/assets/reserve/answer/qrcode.png'
import Radio from '../questionnaire/components/radio.vue'
import Checkbox from '../questionnaire/components/checkbox.vue'
import FillBlank from '../questionnaire/components/fillBlank.vue'
import BriefAnswer from '../questionnaire/components/briefAnswer.vue'
import Scale from '../questionnaire/components/scale.vue'
import Nationality from '../questionnaire/components/nationality.vue'
import District from '../questionnaire/components/district.vue'
import Select from '../questionnaire/components/select.vue'
import IndividualFillBlank from '../questionnaire/components/individualFillBlank.vue'
import MatrixFillBlank from '../questionnaire/components/matrixFillBlank.vue'
import sdDialog from '@/components/dialog/$dialog'
import { questionTypeDict } from '@/utils/dict.js'
export default {
    components: {
        Radio,
        Checkbox,
        FillBlank,
        BriefAnswer,
        Scale,
        Nationality,
        District,
        Select,
        IndividualFillBlank,
        MatrixFillBlank,
        sdDialog
    },
    data() {
        return {
            backImg: backImg,
            qrcodeImg: qrcodeImg,
            answerInfo: {},
            answerList: [],
            questionTypeDict: questionTypeDict,
            env: "", //getENV(),
            showQrcode: false,
            isEnlarged: false
        }
    },
    mounted() {
        const query = this.$route.query
        if (query && query.user_answer_sheet_code) {
            this.token = query.token
            this.user_answer_sheet_code = query.user_answer_sheet_code
            this.$axios({
                url: '/mldyue/user/user-answer-sheet-details',
                data: {
                    token: query.token,
                    user_answer_sheet_code: query.user_answer_sheet_code
                },
                headers: {
                    requestClient: getRequestClient()
                }
            }).then((res) => {
                const answerList = res.data.questions
                delete res.data.questions
                this.answerInfo = res.data
                this.answerList = answerList
            })
        } else {
            Dialog.alert({
                message: '无答卷code',
            })
        }
    },
    methods: {
        /**
            点击返回按钮的回调事件
            @param
            @return
        */
        goback() {
            if (getENV() === 'wxapp') {
                wx.miniProgram.navigateBack({
                    delta: 1
                })
            }
		},

		/**
            处理点击显示二维码事件
            @param
            @return
        */
		handleShowQrcode() {
			this.showQrcode = true
		},
    showEnlarge() {
      this.isEnlarged = true;
    },
    hideEnlarge() {
      this.isEnlarged = false;
    }

    }
}
</script>

<style lang="scss" scoped>
.answer {
    display: flex;
    flex-direction: column;
    height: 100%;
    .questionnaire-title-text {
        padding: 0 0.32rem 0.32rem;
        background: linear-gradient(90deg, #febaba 0%, #f86190 100%);
        .questionnaire-title-back {
            display: inline-block;
            padding: 0.16rem 0.16rem 0 0;
            img {
                display: block;
                width: 0.4rem;
                height: 0.4rem;
            }
        }
        .questionnaire-name {
            display: flex;
            flex-direction: row;
            align-items: center;
            padding-top: 0.4rem;
            padding-bottom: 0.42rem;
            min-height: 1.06rem;
            > span {
                font-size: 0.4rem;
                line-height: 0.56rem;
                font-weight: bold;
                color: #fff;
            }
            .questionnaire-name-desc {
                padding: 0.08rem 0.16rem;
            }
            img {
                display: block;
                width: 0.32rem;
                height: 0.32rem;
            }
        }
    }

    .answer-content {
		flex: 1;
		position: relative;
        padding: 0 0.32rem;
        .answer-content-title {
            position: relative;
            height: 1.12rem;
            padding-left: 0.6rem;
            padding-top: 0.12rem;
            border-bottom: 0.02rem dashed #d3d3d4;
        }
        .answer-content-score {
            font-size: 0.24rem;
            color: #564a4e;
            > span {
                margin-right: 0.08rem;
                font-size: 0.64rem;
                line-height: 0.9rem;
                color: #f86190;
            }
        }
        .answer-content-qrcode {
            display: flex;
            flex-direction: row;
            align-items: center;
            position: absolute;
            right: 0.32rem;
            top: 0;
            bottom: 0;
            height: 0.48rem;
            padding: 0 0.32rem;
            margin: auto 0;
            border-radius: 0.48rem;
            border: 0.02rem solid #e56c90;
            background: rgba(229, 108, 144, 0.06);
            > img {
                width: 0.32rem;
                height: 0.32rem;
            }
            > span {
                margin-left: 0.08rem;
                font-size: 0.24rem;
                line-height: 0.32rem;
                color: #f86190;
            }
        }
        .answer-list {
			overflow-y: auto;
			position: absolute;
			bottom: 0;
			left: 0rem;
			right: 0rem;
            padding: 0.48rem 0.64rem 1.22rem;
        }
        .answer-item {
            margin-bottom: 0.48rem;
        }
    }

    .questionnaire-qrcode {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 0.32rem;
        > img {
            width: 1.92rem;
            height: 1.92rem;
        }
        > span {
            margin-top: 0.16rem;
            font-size: 0.24rem;
            line-height: 0.34rem;
            color: #c3c3c3;
        }
    }
}

.enlarged-image-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.enlarged-image {
  max-width: 90%;
  max-height: 90%;
}
</style>



// WEBPACK FOOTER //
// src/pages/reserve/answer/index.vue